var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassicInspiration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-29 -495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(38.011 499.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M341.833,263.8a13.627,13.627,0,0,1-5.694,11.112v1.954a1.127,1.127,0,0,1-1.126,1.136H328.88c.113-.932,1.431-11.686,4.776-14.2a.31.31,0,0,0,.051-.04.562.562,0,0,0,.124-.79.557.557,0,0,0-.783-.131.2.2,0,0,1-.056.04,7.841,7.841,0,0,1-9.242-.028.561.561,0,0,0-.772.091.57.57,0,0,0,.051.778c.039.04,4.151,4.017,4.725,14.277h-6.139a1.131,1.131,0,0,1-1.126-1.136v-1.954A13.589,13.589,0,1,1,341.833,263.8Z",
    transform: "translate(-314.8 -250.17)",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(8.426 29.107)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 7.345,
    transform: "translate(1.416 1.418)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M339.986,300.526v1.7a.564.564,0,0,1-.566.566h-9.044a.564.564,0,0,1-.566-.566v-1.7a.568.568,0,0,1,.566-.566h9.044A.568.568,0,0,1,339.986,300.526Z",
    transform: "translate(-329.81 -299.96)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(10.084 33.213)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 4.03,
    transform: "translate(1.416 1.416)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 6.861,
    height: 2.831,
    rx: 1,
    transform: "translate(0 0)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M335.85,282.735a18.1,18.1,0,0,0-2.31-6.555,6.663,6.663,0,0,0,4.4.123A22.933,22.933,0,0,0,335.85,282.735Z",
    transform: "translate(-322.267 -260.309)",
    fill: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3985",
    "data-name": "Rectangle 3985",
    width: 45,
    height: 45,
    transform: "translate(29 495)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicInspiration);
export default __webpack_public_path__ + "static/media/classic-inspiration.c60c27cfa584ae75e66ff94e64e7b7d9.svg";
export { ForwardRef as ReactComponent };